import API_URLS from '../links';

export const getDietPlans = (creds,gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_DIET_PLANS + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token,
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addDietPlan = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_DIET_PLAN, {
        method: 'POST',
        headers: {
          access_token: creds.access_token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
export const deleteDietPlan = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_DIET_PLAN + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateDietplan = (creds, formData, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_DIET_PLAN + `/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
